(function ($, Drupal, window, document, undefined) {
  Drupal.behaviors.folderkiezer = {
    attach: function (context, settings) {
      Drupal.behaviors.folderkiezer.back();
      Drupal.behaviors.folderkiezer.alert();
    },

    back: function () {
      $('[js-hook-back]').each(function () {
        $(this).on('click', function (e) {
          e.preventDefault();
          window.history.go(-1);
        });
      });
    },

    alert: function () {
      $('.alert').each(function () {
        $(this).addClass('hide');
      });
    },
  };
})(jQuery, Drupal, this, this.document);
